import React from 'react';

const UserandRole = () => {
  return (
    <div className="p-6 text-gray-800">
      <div className="text-4xl mb-4 text-[#3D6643]">👥</div>
      <h2 className="text-2xl font-bold text-[#3D6643] mb-4">User & Role Management</h2>
      <p className="text-sm mb-4">
        Ensure secure and efficient access by defining clear roles and responsibilities for your team.
      </p>

      <ul className="list-disc list-inside text-sm mb-4 space-y-2">
        <li><strong>Admin Control:</strong> Full system access to manage settings, users, and villa data.</li>
        <li><strong>Role-Based Access:</strong> Assign permissions based on roles like Manager, Staff, or Support.</li>
        <li><strong>Secure Logins:</strong> Protect access with unique credentials and optional two-factor authentication.</li>
        <li><strong>User Activity Logs:</strong> Track who did what and when for accountability.</li>
        <li><strong>Custom Roles:</strong> Create custom user roles to match your operational structure.</li>
      </ul>

      <p className="text-sm">
        Keep your platform secure while empowering your team to perform their roles effectively.
      </p>
    </div>
  );
};

export default UserandRole;